module.exports = __webpack_public_path__ + "22d1e33580ed06cdf4d7cf69249df23b.jpg";